/** Cache identity for the safe post-processing experiment variant lookup. */
export const DICTATION_POST_PROCESSING_VARIANT_QUERY_KEY =
  'dictationPostProcessingVariant';
